import React, { Component } from "react";
import { ListGroup, Container } from "react-bootstrap";

import styled from "styled-components";
import ContactForm from "./contact-form";
import Circuit from "./images/stockIMG.jpg";
import Footer from "./footer";
import NewSupplierRequestForm from "./msds/PR-1017F4_RevB_fillable.pdf";

const StyledContainer = styled(Container)`
  margin-top: 75px;
`;
class newSuppliersRequestForm extends Component {
  render() {
    return (
      <div>
        <img id="heroimage" src={Circuit} alt="Circuit Board" />
        <div className="jumbotron contactJumbotron">
          <h1 id="careersHeader">
            New Supplier Request Form
          </h1>
          <br></br>
          <embed src={NewSupplierRequestForm} type="application/pdf" width="100%" height="720px" />
          
         <div >
          <div class='sk-ww-indeed-jobs' data-embed-id='229958'></div>
        </div>
          <br></br><br></br> {/* Added space jsg 11/15/2022*/}
          
          <ContactForm />

        </div>
        <Footer />
      </div>
    );
  }
}

export default newSuppliersRequestForm;
